module.exports = __webpack_public_path__ + "static/media/HannahHolmes_2026.35108205.jpg";